import MainContainer from "../../components/MainContainer";
import {Link, useLocation} from "react-router-dom";
import NotFound from "../NotFound";
import {concatenateDate} from "../../utils";

const SuccessPage = () => {
  const location = useLocation();
  const payload = location.state?.payload;
  const type = location.state?.type;

  if (!payload) {
    return <NotFound />;
  }

  const getBody = () => {
    switch (type) {
      case "companion":
        return (
          <>
            <h1 className="mb-4">Επιτυχής αποστολή αιτήματος συνοδείας</h1>
            <div className="p-4 border bg-body-tertiary border-success rounded mb-4">
              <p className="mb-0">
                Έχει σταλεί αίτημα συνοδείας για του/της ανηλίκου <strong>{payload?.dependentName}</strong>
                  από τον/την <strong>{payload?.companionName}</strong>{" "}
                  στην εκδήλωση{" "}
                <strong>
                  {payload?.eventDescription} (
                  {concatenateDate(payload?.eventDateTime)})
                </strong>{" "}
                με κωδικό εισιτηρίου <strong>{payload?.ticketCode}</strong>
              </p>
            </div>
            <Link
              to="/tickets/choose-action"
              className="btn btn-primary btn-lg"
            >
              Επιστροφή
            </Link>
          </>
        );
      case "cancel":
        return (
          <>
            <h1 className="mb-4">Επιτυχής ακύρωση αδειοδότησης</h1>
            <div className="p-4 border bg-body-tertiary border-success rounded mb-4">
              <p className="mb-0">
                Ακυρώνεται η συνοδεία του ανήλικου{" "}
                <strong>{payload?.dependentName}</strong> από τον{" "}
                <strong>{payload?.companionName}</strong> στην εκδήλωση{" "}
                <strong>
                  {payload?.eventDescription} (
                  {concatenateDate(payload?.eventDateTime)})
                </strong>{" "}
                με κωδικό εισιτηρίου <strong>{payload?.ticketCode}</strong>
              </p>
            </div>
            <Link
              to="/tickets/choose-action"
              className="btn btn-primary btn-lg"
            >
              Επιστροφή
            </Link>
          </>
        );
      default:
        return (
          <>
            <h1 className="mb-4">Επιτυχής επικύρωση εισιτηρίου</h1>
            <div className="p-4 border bg-body-tertiary border-success rounded mb-4">
              <p className="mb-0">
                Το εισιτήριο με κωδικό <strong>{payload?.ticketCode}</strong>{" "}
                έχει πρoστεθεί στο Gov.gr Wallet του χρήστη{" "}
                <strong>{payload?.fullName}</strong>.
              </p>
            </div>
            <Link
              to="/ticket-office/choose-user"
              className="btn btn-primary btn-lg"
            >
              Προσθήκη νέου εισιτηρίου
            </Link>
          </>
        );
    }
  };

  return (
    <MainContainer>
      <div className="col-lg-8">
        <div className="success-icon mb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#198754"
            viewBox="0 0 512 512"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
          </svg>
        </div>
        {getBody()}
      </div>
    </MainContainer>
  );
};

export default SuccessPage;
